import type { components } from '@/api/types/recommender';

// Type-only import: kept free of runtime imports so the auth helpers can
// validate a buy path without pulling in the API client.

export type ProductKey = components['schemas']['CatalogueProduct']['key'];

export const PRODUCT_KEYS = [
  'topup',
  'seats',
  'hours',
  'silver',
  'gold',
  'platinum',
] as const satisfies readonly ProductKey[];

export const PACKAGE_KEYS = ['silver', 'gold', 'platinum'] as const satisfies readonly ProductKey[];
export type PackageKey = (typeof PACKAGE_KEYS)[number];

/** Every generated key is listed: fails to compile if billing adds one. */
type Missing = Exclude<ProductKey, (typeof PRODUCT_KEYS)[number]>;
const allKeysListed: [Missing] extends [never] ? true : never = true;
void allKeysListed;
